export default {"src":"/_next/static/media/carEmptyCircle_40.baa5d037.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};